<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="left ">First US edition</p>
<p class="left spaceabove1">Copyright © 2018 by Bastei Lübbe AG, Köln</p>
<p class="left ">English translation copyright © 2020 by John Brownjohn</p>
<p class="left spaceabove1">First published in Germany in 2018 as <em>Tante Poldi und der schöne Antonio</em> by Bastei Lübbe AG, Köln</p>
<p class="left spaceabove1">First English-language edition published in Great Britain in 2020 by John Murray Publishers, a Hachette UK company</p>
<p class="left spaceabove1">All rights reserved</p>
<p class="left spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="left spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="left spaceabove1"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="left ">Names: Giordano, Mario, 1963–author. | Brownjohn, John, translator.</p>
<p class="left ">Title: Auntie Poldi and the handsome Antonio / Mario Giordano ; translated by John Brownjohn.</p>
<p class="left ">Other titles: Tante Poldi und der schöne Antonio. English</p>
<p class="left ">Description: First US edition. | Boston : Mariner Books/Houghton Mifflin Harcourt, 2020. | Series: Auntie Poldi series | First published in German in 2018 as Tante Poldi und der schöne Antonio by Bastei Lübbe AG, Köln. First English-language edition published in Great Britain in 2020 by John Murray Publishers, a Hachette UK company. | Translated from the German.</p>
<p class="left ">Identifiers: <span class="smallcaps">LCCN</span> 2019025609 (print) | <span class="smallcaps">LCCN</span> 2019025610 (ebook) | <span class="smallcaps">ISBN</span> 9780358309420 (trade paperback) | <span class="smallcaps">ISBN</span> 9781328518446 (hardcover) | <span class="smallcaps">ISBN</span> 9781328518415 (ebook) | <span class="smallcaps">ISBN</span> 9780358309369 | <span class="smallcaps">ISBN</span> 9780358309369</p>
<p class="left ">Subjects: | <span class="smallcaps">GSAFD:</span> / Mystery fiction.</p>
<p class="left ">Classification: <span class="smallcaps">LCC PT</span>2667.<span class="smallcaps">I</span>5617 <span class="smallcaps">T</span>3413 2020 (print) | <span class="smallcaps">LCC PT</span>2667.<span class="smallcaps">I</span>5617 (ebook) | <span class="smallcaps">DDC</span> 833/.92—<span class="smallcaps">DC</span>23</p>
<p class="left ">LC record available at <a href="https://lccn.loc.gov/2019025609" target="_blank">https://lccn.loc.gov/2019025609</a></p>
<p class="left ">LC ebook record available at <a href="https://lccn.loc.gov/2019025610" target="_blank">https://lccn.loc.gov/2019025610</a></p>
<p class="left spaceabove1">Cover design by Martha Kennedy</p>
<p class="left ">Cover illustration © Chris Andrews</p>
<p class="left ">Hand lettering © Erik Marinovich</p>
<p class="left ">Author photograph © Rica Rosa</p>
<p class="left spaceabove1">v1.0720</p>
<p class="left spaceabove1">All characters in this book are fictitious, and any resemblance to real persons, living or dead, is purely coincidental.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?9fa48188